<template>
  <v-dialog v-model="dialog" persistent width="1550px">
    <v-card>
      <v-card-title class="headline mb-0">
        <v-icon>close</v-icon> Rechazar permiso
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0 px-4">
        <v-container grid-list-md class="p-0" style="min-width: 100%;">
          <v-layout row wrap>
            <v-flex xs12>
              <span class="subtitulo"
                ><strong>Número:</strong> {{ permiso.numero }}</span
              >
            </v-flex>
            <v-flex xs12>
              <span class="subtitulo">
                <strong>Funcionario:</strong> {{ permiso.nombres }}
              </span>
            </v-flex>
            <v-flex xs12>
              <span class="subtitulo">
                <strong>Tipo de papeleta:</strong> {{ permiso.tipo_permiso }}
              </span>
            </v-flex>
            <!--<v-flex xs12 v-if="permiso.id_tipo_permiso == 8">
              <h3>
                <strong>Lugar de atencion:</strong> {{ permiso.lugar_atencion }}
              </h3>
            </v-flex>  -->
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 87">
              <span class="subtitulo"
                ><strong>Lugar de comisión :</strong> {{ permiso.lugar }}</span
              >
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 5">
              <span class="subtitulo">
                <b>
                  {{ permiso.id_parametro_permiso ? tipo_capacitacion : "" }}
                </b>
              </span>
            </v-flex>
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == 87 ||
                  permiso.id_tipo_permiso == 96 ||
                  permiso.id_tipo_permiso == 101
              "
            >
              <h3><strong>Motivo:</strong> {{ permiso.permiso.motivo }}</h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 90">
              <h3>
                <strong>Tipo de baja:</strong> {{ permiso.permiso.motivo }}
              </h3>
            </v-flex>

            <v-flex xs12 v-if="permiso.id_tipo_permiso == 44">
              <h3>
                <strong>Condición o estado crítico de salud :</strong>
                {{ permiso.permiso.motivo }}
              </h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <span class="titulo-rechazar">Detalles de papeleta.</span>
            </v-flex>
          </v-layout>
          <!-- permisos justificativo caja nro 8 -->
          <v-layout v-if="permiso.id_tipo_permiso == 8">
            <v-flex xs12>
              <v-data-table
                class="tabla-comprimida-light elevation-1"
                :items="permiso_detalles2"
                hide-actions
                :headers="headers_caja"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_desde, "HH:mm")
                        .add("00:20")
                        .format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_hasta, "HH:mm")
                        .add("00:20")
                        .format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.total_horas, "HH:mm").format("HH:mm")
                    }}
                  </td>
                  <td
                    v-if="permiso.id_tipo_permiso == 24"
                    class="text-xs-center"
                  >
                    {{ props.item.total_dias }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por horas -->
          <v-layout>
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == 87 ||
                  permiso.id_tipo_permiso == 96 ||
                  permiso.id_tipo_permiso == 88 ||
                  permiso.id_tipo_permiso == 102 ||
                  (permiso.id_tipo_permiso >= 37 &&
                    permiso.id_tipo_permiso <= 43)
              "
            >
              <v-data-table
                class="tabla-comprimida-light elevation-1"
                :items="permiso_detalles2"
                hide-actions
                :headers="headers_horas"
              >
                >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>

                  <td
                    class="text-xs-center"
                    v-if="permiso.id_tipo_permiso != 102"
                  >
                    {{
                      $moment(props.item.total_horas, "HH:mm").format("HH:mm")
                    }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="permiso.id_tipo_permiso == 102"
                  >
                    {{
                      $moment(props.item.total_horas, "HH:mm").format("HH:mm")
                    }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias decimales -->
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 14 ||
              permiso.id_tipo_permiso == 105 ||
                (permiso.id_tipo_permiso >= 98 &&
                  permiso.id_tipo_permiso <= 101) ||
                permiso.id_tipo_permiso == 89 ||
                permiso.id_tipo_permiso == 18
            "
          >
            <v-flex xs12>
              <v-data-table
                class="tabla-comprimida-light elevation-1"
                :items="permiso_detalles2"
                hide-actions
                :headers="headers_dias_decimales"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias completos-->
          <v-layout
            v-if="
              [6, 44, 95, 61, 12, 90, 5].includes(
                parseInt(permiso.id_tipo_permiso)
              )
            "
          >
            <v-flex xs12>
              <v-data-table
                class="tabla-comprimida-light elevation-1"
                :items="permiso_detalles2"
                hide-actions
                :headers="headers_dias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos 94 formulario de registro de asistencias-->
          <v-layout v-if="permiso.id_tipo_permiso == 94">
            <v-flex xs12>
              <v-data-table
                class="tabla-comprimida-light elevation-1"
                :items="permiso_detalles2"
                hide-actions
                :headers="headers_registro_asistencias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos nro 24 no aprueba -->
          <!-- compensacion -->
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 88 ||
                (permiso.id_tipo_permiso == 96 &&
                  permiso.compensa_tolerancia == 1)
            "
          >
            <span class="titulo-rechazar"> Detalles compensacion</span>
          </v-layout>
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 88 ||
                (permiso.id_tipo_permiso == 96 &&
                  permiso.compensa_tolerancia == 1)
            "
          >
            <v-flex xs12>
              <v-data-table
                class="tabla-comprimida-light elevation-1"
                :items="permiso_compensacion"
                hide-actions
                :headers="headers2"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{ props.item.diferencia_horas }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout
            class="pa-2"
            v-if="
              permiso.id_tipo_permiso == 88 ||
                (permiso.id_tipo_permiso == 96 &&
                  permiso.compensa_tolerancia == 1)
            "
          >
            <v-flex xs12>
              <h4>
                <strong>Total horas: {{ total_horas_acomuladas }}</strong>
              </h4>
            </v-flex>
          </v-layout>
          <!--SEGUIMIENTO -->
          <v-layout class="text-xs-center">
            <span class="titulo-rechazar"> Seguimiento de papeleta</span>
          </v-layout>

          <v-layout>
            <v-flex xs12>
              <v-data-table
                class="tabla-comprimida-light elevation-1"
                :items="detalle_seguimiento"
                hide-actions
                :headers="headers_detalle"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_registro }}
                  </td>
                  <td class="text-xs-center">{{ props.item.estado }}</td>
                  <td class="text-xs-center">{{ props.item.usuario }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md12>
              <v-textarea
                class="text-field-reducido-border"
                v-model="form.justificacion_rechazo"
                rows="2"
                label="Justificación del rechazo"
                auto-grow
                :rules="$validate(['required'])"
                required
                outline
                clearable
              >
              </v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions class="px-4">
        <v-spacer></v-spacer>
        <v-btn color="secundary" @click.prevent="close()" :loading="loading"
          ><v-icon>check</v-icon>
          Cancelar
        </v-btn>

        <v-btn color="error" @click.prevent="apruebaRechazaPermiso(permiso)"
          ><v-icon>clear</v-icon>
          Rechazar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  components: {
    SeguimientoDetalle
  },
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogRechazarPermisoRRHH", async item => {
      this.permiso = item;
      (this.permiso_detalles2 = [
        {
          fecha_salida: this.permiso.fecha_desde,
          fecha_hasta: this.permiso.fecha_retorno,
          hora_desde: this.permiso.hora_desde,
          hora_hasta: this.permiso.hora_hasta,
          total_horas: this.permiso.horas_permiso,
          total_dias: this.permiso.nro_dias
        }
      ]),
        this.total_horas();
      if (this.permiso.id_tipo_permiso && this.permiso.id_tipo_permiso != 24) {
        this.getDetallePermiso(this.permiso.id_permiso);
        this.verPermisosCompensacion(this.permiso.id_permiso);
        this.getDetalleSeguimiemto(this.permiso.id_permiso);
      } else {
        this.getDetallePermiso(this.permiso.id_vacacion);
        this.verPermisosCompensacion(this.permiso.id_vacacion);
        this.getDetalleSeguimiemto(this.permiso.id_vacacion);
      }
      // Buscamos tipo participacion censo
      if (this.permiso.id_tipo_permiso == 5) {
        this.tipo_capacitacion = await this.obtenerAgenteCapacitacion(
          this.permiso.id_parametro_permiso
        );
      }
      this.dialog = true;
    });
  },
  data() {
    return {
      dialog: false,
      form: {},
      permiso: {
        rechazo: ""
      },
      permiso_compensacion: [],
      total_horas_acomuladas: 0,
      permiso_detalles: [],
      permiso_detalles2: [],
      detalle_seguimiento: [],
      loading: false,
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_registro_asistencias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        }
      ],
      headers_caja: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "tolerancia",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },

        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Tolerancia hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias_decimales: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_horas: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_detalle: [
        {
          text: "Fecha registro",
          sortable: false,
          align: "center"
        },
        {
          text: "Estado",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario",
          sortable: false,
          align: "center"
        }
      ],
      horas_solicitadas: 0,
      // Variable censo
      tipo_capacitacion: {}
    };
  },
  methods: {
    // Metodo para obtener tipos de capacitacion censo
    async obtenerAgenteCapacitacion(id_parametro) {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              param(id:${id_parametro}){
                valor
              }
            }
          `
        });
        return res.param.valor;
      } catch (error) {
        console.log(error);
      }
    },
    async verPermisosCompensacion(id_permiso) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          this.permiso_compensacion = respuesta.runQuery.respuesta;
        } else {
          this.permiso_compensacion = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                respuesta
              }
            }

          `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.dialog = false;
      this.permiso = {
        permiso: {
          motivo: ""
        }
      };
      this.$bus.$emit("closeDialogRechazarPermisosRRHH");
    },

    sumar_horas(permiso_detalles) {
      let total = 0;
      permiso_detalles.forEach(item => {
        total +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas = total;
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    },
    async getDetallePermiso(id_permiso) {
      try {
        let res = await this.$service.graphql({
          query: `
			      query{
              vDetallePermisos(id_permiso: ${id_permiso}){
                rows{
                  id
                  id_permiso
                  fecha_desde
                  fecha_hasta
                  hora_desde
                  hora_hasta
                  total_dias
                  total_horas

                }
              }
            }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;

        this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
        let respuesta;
        let res;
        respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                respuesta
              }
            }
          `
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
        res = await this.$service.graphql({
          query: `
            query{
              vSeguimientoDetalles(id:${id}){
                rows{
                  fecha_registro
                  estado
                  usuario
                  jefe
                  id_estado
                  motivo
                  jefe
                }
              }
            }
          `
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async apruebaRechazaPermiso(permiso) {
      try {
        if (!this.form.justificacion_rechazo) {
          this.$message.info("No lleno el justificativo de rechazo");
          return;
        }
        this.$confirm("¿Está seguro de rechazar el permiso?", async () => {
          this.form.justificacion_rechazo = this.form.justificacion_rechazo.replace(
            /\n/g,
            " "
          );
          const user = this.$storage.get("user");
          let respuesta = "";
          respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_rechazo_permisos_por_jefes_rrhh(${permiso.id_permiso},${user.id},'${this.form.justificacion_rechazo}','','{}')"){
                respuesta
              }
            }
          `
          });
          let resp =
            respuesta.runQuery.respuesta[0].fn_rechazo_permisos_por_jefes_rrhh;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            // Enviamos correo de rechazo
            let datos_persona_permiso = await this.obtenerDatosPersonaCorreo(
              permiso.id_persona
            );
            if (datos_persona_permiso) {
              var mensaje = `
              <h1>NOTIFICACIÓN - RECHAZO DE PERMISO</h1>
              Estimado(a): ${datos_persona_permiso.nombres} ${
                datos_persona_permiso.ap_paterno
              } ${datos_persona_permiso.ap_materno}<br>
              Comunicarle que la papeleta con los siguientes datos:<br>
              <b>NRO DE PAPELETA:</b><br>${permiso.numero}<br>
              <b>TIPO DE PERMISO:</b><br>${permiso.tipo_permiso}<br>
              <b>FECHA DEL PERMISO:</b><br>${permiso.fecha_desde} - ${
                permiso.fecha_retorno
              }<br><br>
              Fue rechazada por el siguiente motivo:<br>
              ${this.form.justificacion_rechazo.toUpperCase()}<br><br>
              Ingrese al sistema para ver mas detalles.
              `;
              await this.$service.sendEmail({
                correo: datos_persona_permiso.correo,
                asunto: `NOTIFICACIÓN - RECHAZO DE PERMISO SAP`,
                mensaje: mensaje.replace(/<[^>]+>/g, ""),
                html: mensaje
              });
            } else {
              this.$message.info(
                "No se notifico por correo ya que el servidor no posee un correo registrado"
              );
            }
            this.$alert("El permiso fué rechazado", () => {});
            this.close();
          } else {
            this.$alert(resps2[1], () => {});
            this.close();
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Metodo para obtener los datos de la persona
    async obtenerDatosPersonaCorreo(id_persona) {
      try {
        let rpta = await this.$service.graphql({
          query: `
          query{
            persona(id:${id_persona}){
              ap_paterno
              ap_materno
              nombres
              usuarios{
                correo
              }
            }
          }
        `
        });
        var datos_persona = rpta.persona;
        if (datos_persona) {
          datos_persona = {
            ap_paterno: datos_persona.ap_paterno,
            ap_materno: datos_persona.ap_materno,
            nombres: datos_persona.nombres,
            correo: datos_persona.usuarios[0]
              ? datos_persona.usuarios[0].correo
              : null
          };
        }
        return datos_persona;
      } catch (error) {
        console.log(error);
      }
    },

    async apruebaRechazaPermisoOld(permiso, id_estado) {
      const user = this.$storage.get("user");
      console.log("++", this.form.justificacion_rechazo);
      if (!this.form.justificacion_rechazo) {
        this.$message.info("Ingrese la justificación del rechazo");
        return;
      }
      let respuesta = "";

      if (this.permiso.id_tipo_permiso == 96) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_tolerancia(${permiso.id_permiso},${id_estado},${user.id},'${this.form.justificacion_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_tolerancia;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 7) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            console.log("entra");
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 102) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_anula_o_rechaza_horario_continuo(${permiso.id_permiso},16,${this.permiso.id_persona},'${user.id}','${this.form.justificacion_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp =
            respuesta.runQuery.respuesta[0].fn_anula_o_rechaza_horario_continuo;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 12) {
        // cambiar funcion para aprobar

        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                  runQuery(consulta:"select control.fn_aprueba_rechaza_permiso_matrimonio(${permiso.id_permiso},'${id_estado}','${user.id}',${user.id_persona},'${this.form.justificacion_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp =
            respuesta.runQuery.respuesta[0]
              .fn_aprueba_rechaza_permiso_matrimonio;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 7) {
            console.log("entra");
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            console.log("entra");
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 44) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_ds3462(${permiso.id_permiso},${id_estado},${user.id},'${this.form.justificacion_rechazo}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_ds3462;
          let resps2 = resp.split("|");

          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 90) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                  runQuery(consulta:"select control.fn_aprueba_permiso_rrhh_baja_medica(${permiso.id_permiso},${permiso.id_persona},${id_estado},'${user.id}','${this.form.justificacion_rechazo}')"){
                  respuesta
                }
              }
            `
          });
          let resp =
            respuesta.runQuery.respuesta[0].fn_aprueba_permiso_rrhh_baja_medica;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 7) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 95) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{

                  runQuery(consulta:"select control.fn_aprueba_rechaza_permiso_matrimonio(${permiso.id_permiso},'${id_estado}','${user.id}',${user.id_persona},'${this.form.justificacion_rechazo}')"){
                  respuesta
                }
              }
            `
          });
          let resp =
            respuesta.runQuery.respuesta[0]
              .fn_aprueba_rechaza_permiso_matrimonio;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 7) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            console.log("entra");
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 89) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},16,${user.id},${this.permiso.id_persona},'${this.form.justificacion_rechazo}')"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Rechazar permiso sin goce de haberes p18
      if (this.permiso.id_tipo_permiso == 18) {
        let consulta = `SELECT control.fn_envia_permiso_sin_haber(${permiso.id_permiso},${id_estado},${user.id},${this.permiso.id_persona},'${this.form.justificacion_rechazo}')`;
        try {
          respuesta = await this.$service.graphql({
            query: `
                    query{

                        runQuery(consulta:"${consulta}"){
                        respuesta
                      }
                    }
                  `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_sin_haber;
          let resps = resp.split("|");
          if (resps[0] == "1" && id_estado == 7) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      // rechaza permiso dia de la mujer p100
      if (this.permiso.id_tipo_permiso == 100) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},16,${user.id},${this.permiso.id_persona},'${this.form.justificacion_rechazo}')"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Rechaza permiso asueto dia de la madre p99
      if (this.permiso.id_tipo_permiso == 99) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},16,${user.id},${this.permiso.id_persona},'${this.form.justificacion_rechazo}')"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(mensaje, () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Rechaza permiso asueto dia del padre p98
      if (this.permiso.id_tipo_permiso == 98) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},16,${user.id},${this.permiso.id_persona},'${this.form.justificacion_rechazo}')"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Rechaza permiso asueto otros p101
      if (this.permiso.id_tipo_permiso == 101) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},16,${user.id},${this.permiso.id_persona},'${this.form.justificacion_rechazo}')"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 8) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_aprueba_justifica_caja(${permiso.id_permiso},16,${user.id},'${this.form.justificacion_rechazo}')"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_justifica_caja;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      this.close();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/RechazarPermisoRRHH.vue